export const hi = {
    "TRIGGER_LISTEN": "ट्रिगर्स के लिए सुन रहे हैं",
    "ASSIST_EMPTY_MSG": "एजेंट AI आपकी बातचीत को सक्रिय रूप से सुन रहा है और तत्काल सहायता के लिए तैयार है जब ट्रिगर होता है।",
    "MYBOT_TRIGGET_LISTEN": "वर्तमान में कोई सक्रिय मेरा बॉट कार्य नहीं है",
    "MYBOT_EMTPY_MSG": "मेरे बॉट पर कोई कार्य शुरू करने के लिए, खोज टैब पर जाएं और अपने इच्छित कार्य के लिए \"\"एजेंट इनपुट्स के साथ चलाएं\"\" विकल्प को चुनें।",
    "PROACTIVE_MODE": "प्रोएक्टिव मोड",
    "SETTINGS": "सेटिंग्स",
    "HELP_AND_SUPPORT": "सहायता और समर्थन",
    "HELP": "सहायता",
    "LANGUAGE": "भाषा",
    "FILE_NAME":"फ़ाइल नाम",
    "THEME": "थीम",
    "AUTO_SCROLL_TOOLTIP":"सहायता टैब, मेरा बॉट और प्रतिलिपि टैब की सामग्री के स्वतः स्क्रॉलिंग को नियंत्रित करता है",
    "AUTOMATIC": "स्वचालित",
    "DARK": "डार्क",
    "LIGHT": "लाइट",
    "THEME_DESC": "इससे आपके सिस्टम की डिफ़ॉल्ट मोड का उपयोग होगा",
    "DOCUMENTATION": "दस्तावेज़ीकरण",
    "DOC_DESC": "हमारे गहन दस्तावेज़ीकरण लेखों को देखें।",
    "FAQ_U": "सामान्य प्रश्न",
    "FAQ_DESC": "प्रायः पूछे जाने वाले प्रश्न",
    "KORE_ACADEMY": "कोरे अकादमी",
    "KORE_ACA_DESC": "अकादमी कोर्स के माध्यम से एजेंट AI के बारे में और अधिक जानें।",
    "SEARCH": "खोज",
    "TAB_TEXT":"कोई टैब सक्षम नहीं है! कृपया कम से कम एक टैब सक्षम करें",
    "MY_BOT": "मेरा बॉट",
    "ASSIST": "सहायता",
    "TRANSCRIPT": "ट्रांसक्रिप्ट",
    "HISTORY": "इतिहास",
    "STARTOVER": "फिर से शुरू करें",
    "RESTART_INPUTS": "जुटाए गए इनपुट्स के साथ पुनः आरंभ करें",
    "ASKCUSTOMER": "ग्राहक से पूछें",
    "TELLCUSTOMER": "ग्राहक को बताएं",
    "WELCOME_MSG": "स्वागत संदेश",
    "TAP_SEARCH":"खोज के लिए टैप करें",
    "SEND": "भेजें",
    "SENT": "भेज दिया गया",
    "AWAITING": "प्रतिक्रिया की प्रतीक्षा कर रहा है | जारी रखने के लिए टाइप करें",
    "OVERRIDE": "जारी रखने के लिए टाइप करें",
    "OVERRIDE_FILE": "जारी रखने के लिए फ़ाइल अनुलग्न करें",
    "ACCEPT_RESPONSE": "प्रतिक्रिया स्वीकृत",
    "AGENT_ENTERED": "एजेंट प्रवेश किया",
    "EXPECTED_FORMAT": "अपेक्षित प्रारूप",
    "INPUT_VALUES": "इनपुट मान",
    "RESTART": "पुनः आरंभ",
    "START_OVER": "फिर से शुरू करें",
    "RESTART_CAPTURE": "जुटाए गए इनपुट्स के साथ पुनः आरंभ करें",
    "CANCEL": "रद्द करें",
    "INTERRUPT_DIALOG": "बाधित संवाद कार्य",
    "RUN": "चालू",
    "RUN_AGENT": "एजेंट के इनपुट के साथ चलाएं",
    "STEP": "कदम",
    "DIALOG_TASK": "संवाद कार्य",
    "FAQ": "प्रायः पूछे जाने वाले प्रश्न",
    "SNIPPET": "उत्तर",
    "ARTICLE": "वेब पेज",
    "FILE": "फ़ाइलें",
    "SUGGESTED": "सुझाव दिए गए",
    "ALL_DIALOG": "सभी संवाद कार्य",
    "DIALOG_TEXT": "संवाद",
    "INTENT_IDENTIFIED": "ग्राहक का उक्ति",
    "NOT_WHAT_LOOKING": "गलत सुझाव?",
    "BOT": "बॉट",
    "CUSTOMER": "ग्राहक",
    "YOU": "आप",
    "TERMINATE_CONV": "संवाद कार्य समाप्त करें",
    "TERMINATE_CONV_DESC": "क्या आप सुनिश्चित हैं कि आप संवाद कार्य को समाप्त करना चाहते हैं? एजेंट AI अब सुझाव नहीं दे सकेगा।",
    "YES_TERMINATE": "हां, समाप्त करें",
    "NO_CANCEL": "नहीं, रद्द करें",
    "OVERRIDE_CONTINUE": "ओवरराइड मोड के साथ जारी रखें",
    "SUMMARY_TEXT": "सारांश",
    "SUBMIT": "प्रस्तुत करें",
    "INTERRUPT_OCCURED": "बाधा हुई",
    "IDENTIFIED_INTENT": "पहचानी गई इरादा",
    "INTERRUPT_DESC": "इसे चलाने से आपका चल रहा संवाद कार्य समाप्त हो जाएगा।",
    "ACCEPT_RUN": "स्वीकार करें और चलाएं",
    "RUN_LATER": "बाद में चलाएं",
    "KNOW_MORE": "अधिक जानें",
    "MORE_TEXT": "अधिक",
    "LESS_TEXT": "कम",
    "VIEW_MORE": "अधिक देखें",
    "VIEW_LESS": "कम देखें",
    "SHOW_MORE_FAQ": "और अधिक FAQs दिखाएं",
    "SHOW_LESS_FAQ": "कम FAQs दिखाएं",
    "SHOW_MORE_ARTICLE": "और अधिक वेब पेज दिखाएं",
    "SHOW_LESS_ARTICLE": "कम वेब पेज दिखाएं",
    "SHOW_MORE_SNIPPET": "और अधिक उत्तर दिखाएं",
    "SHOW_LESS_SNIPPET": "कम उत्तर दिखाएं",
    "SHOW_MORE_FILES": "और अधिक फ़ाइलें दिखाएं",
    "SHOW_LESS_FILES": "कम फ़ाइलें दिखाएं",
    "VIEW_ALL_DIALOG": "सभी संवाद देखें",
    "VIEW_FEW_DIALOG": "कुछ संवाद देखें",
    "HELP_FULL": "उपयोगी?",
    "THANKYOU": "धन्यवाद!",
    "EXPAND_MORE": "विस्तार / अधिक",
    "CLOSE_TEXT": "बंद",
    "STARTED": "शुरू किया गया",
    "ENDED": "समाप्त",
    "VIEW_FULL_ARTICLE": "वेब पेज देखें",
    "VIEW_FULL_FILE": "फ़ाइल देखें",
    "COPIED": "कॉपी किया गया",
    "SENTI_ANALY": "भावना विश्लेषण",
    "WRONG_SUGGESTION": "गलत सुझाव",
    "INCORRECT_INTENT": "गलत इरादा",
    "ACCIDENTAL_CLICK": "अक्सरी क्लिक",
    "TIME_TAKING": "समय लेना",
    "OTHER": "अन्य",
    "PLAYBOOK_EMPTY_MSG": "प्लेबुक चुनें",
    "PLAYBOOK_EMPTY_DESC": "सभी उपलब्ध प्लेबुक्स डायनेमिक होने के कारण एजेंट AI प्लेबुक लोड नहीं कर सकता है। प्लेबुक तक पहुँचने के लिए 'प्लेबुक चुनें' पर क्लिक करें।",
    "STAGE": "स्टेज",
    "PROCEED_TO_CLOSE": "बंद करने के लिए आगे बढ़ें",
    "RECOMENDED_PLAYBOOK": "सिफारिश की गई प्लेबुक",
    "PRIMARY_SCRIPTS": "मुख्य स्क्रिप्ट",
    "DYNAMIC_SCRIPTS": "डायनेमिक स्क्रिप्ट्स",
    "RESUME": "फिर से शुरू करें",
    "ENABLE_CLOSE": "स्टेज बंद करने के लिए आगे बढ़ने के लिए 'बंद करने के लिए आगे बढ़ें' पर क्लिक करें",
    "LIST_VIEW": "सूची दृश्य",
    "TERMINATE": "समाप्त करें",
    "MINIMIZE": "कम करें",
    "MAXIMIZE": "अधिक करें",
    "NO_SEARCH_RESULT": "कोई भी खोज परिणाम नहीं मिला",
    "SENTIMENT_AWAITING": "भावना के लिए प्रतीक्षा कर रहे हैं",
    "POSITIVE": "सकारात्मक",
    "NEGATIVE": "नकारात्मक",
    "ASSOCIATED_WORK_NOTES": "गुजरी हुई समाधान नोट्स",
    "AGENT_JOINED_CONV": "एजेंट बातचीत में शामिल हुआ",
    "AUTOSCROLL_ASSIST": "ऑटो-स्क्रॉल सहायता टैब सामग्री",
    "FILE_SIZE_MSG": "फ़ाइल का आकार 25MB के भीतर होना चाहिए। कृपया पुनः प्रयास करें। प्रयास करें।",
    "OVERRIDE_BTN": "ओवरराइड",
    "CHOOSE_FILE": "फ़ाइल चुनें",
    "SUMMARY_ERROR_TEXT": "हमें खेद है, लेकिन इस बातचीत के लिए सारांश बनाने में समस्या आ गई। कृपया अपना खुद का सारांश बनाएं।",
    "ASK_A_QUESTION": "सवाल पूछें",
    "COPY" : "प्रतिलिपि",
    "TELL_US_MORE": "हमें अधिक बताएं",
    "THANKS_FEEDBACK": "आपकी प्रतिक्रिया के लिए धन्यवाद",
    "SOMETHING_WRONG": "कुछ गलत हुआ",
    "CLICK_ERROR_DETAILS": "त्रुटि विवरण देखने के लिए क्लिक करें",
    "NO_ACTIVE_PLAYBOOK": "कोई सक्रिय प्लेबुक नहीं है",
    "PLAYBOOK": "प्लेबुक",
    "REPHRASE_QUESTION": "क्या आप अपना सवाल फिर से पूछ सकते हैं या कुछ और पूछ सकते हैं?",
    "INTERNAL_INFO": "आंतरिक जानकारी",
    "SOURCES": "स्रोत",
    "CONVERSATION_SUMMARY": "संवाद का सारांश",
    "WAITING": "प्रतीक्षा कर रहा है",
    "WIDGET_DISABLED": "विजेट अक्षम कर दिया गया है",
    "AI_SETTINGS_DISABLED": "एआई सेटिंग्स अक्षम हैं! कृपया एआई प्रशासक से संपर्क करें",
    "SERVER_CONNECTION_ERROR": "सर्वर से कनेक्ट करने में त्रुटि",
    "VIEW": "देखें",
    "ATTACHMENT_INPUT": "अटैचमेंट इनपुट",
    "TYPE_SUMMARY": "सारांश लिखें",
    "VIEW_FULL_ARTICLE_2": "पूर्ण लेख देखें",
    "VIEW_FULL_FILE_2": "पूर्ण फ़ाइल देखें",
    "BY":"द्वारा",
    GENERATE_SUMMARY: "सारांश उत्पन्न करें",
    PREV_SUMMARIES: "पहले उत्पन्न सारांश",
    DIALOG_WORKFLOWS: "डायलॉग वर्कफ़्लो",
    SHOW_ALL_DIALOG: "सभी डायलॉग कार्य दिखाएं",
    SHOW_ALL_DIALOGS: "सभी डायलॉग दिखाएं",
    CUSTOM_TAB: "कस्टम टैब",
    AGENT_INPUT: "एजेंट इनपुट",
    "CUSTOM_EMPTY_MSG" : "कोई सक्रिय वर्कफ़्लो नहीं है",
    "CUSTOM_TAB_DESC" : "एक वर्कफ़्लो शुरू करने के लिए, स्क्रीन के नीचे मौजूद सूची से एक चलाएं।",
    "SUBMIT_OVERALL_FEEDBACK" : "समग्र प्रतिक्रिया जमा करें",
    "FEEDBACK_POPUP_SUBTITLE" : "विजेट और इसकी सुविधाओं के बारे में आपकी संतुष्टता",
    "FEEDBACK_SATISFIED" : "संतुष्ट",
    "FEEDBACK_UNSATISFIED" : "संतुष्ट नहीं",
    "FEEDBACK_PROVIDE_REASONS" : "अधिक जानकारी दें…",
    "FEEDBACK_TITLE" : "प्रतिक्रिया",
    "AGENTIC_THINKING" : "सोच रहा है",
    "AGENTIC_AGENT_TITLE" : "एजेंट",
    "AGENTIC_COPILOT_MODE_TITLE" : "एजेंटिक कोपिलॉट मोड",
    "AGENTIC_SENDING_MESSAGE" : "भेजा जा रहा है...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot आपकी बातचीत को सक्रिय रूप से सुन रहा है और स्वचालित रूप से सहायता करने के लिए तैयार है",
    "AGENTIC_SEARCH_RESULTS" : "एजेंट परिणाम"
}